import PropTypes from "prop-types";
import { withTranslation } from "@template/components/translation";
import styles from "./InternationalSites.css";
import withViewport from "../../Viewport/withViewport";
import CountryFlag from "../../CountryFlag";
import { keys } from "@template/keysConstants/keys";

const id = "chrome-international-sites";

const InternationalSites = ({
  otherSites,
  formatTranslation,
  onSiteClicked
}) => (
  <div className={styles.internationalSites}>
    <h3 id={id}>{formatTranslation("footer_international_sites_label")}</h3>
    <ul aria-labelledby={id}>
      {otherSites.map(({ countryCode, imageUrl, name, url }) => (
        <li key={name}>
          <a
            role="button"
            href={`//${url}`}
            onClick={e => {
              e.preventDefault();
              onSiteClicked(countryCode);
            }}
            onKeyDown={e => {
              if (e.key === keys.space || e.key === keys.enter) {
                e.preventDefault();
                onSiteClicked(countryCode);
              }
            }}
            aria-label={name}
          >
            <CountryFlag {...{ name, imageUrl }} />
          </a>
        </li>
      ))}
    </ul>
  </div>
);

InternationalSites.propTypes = {
  otherSites: PropTypes.arrayOf(
    PropTypes.shape({
      countryCode: PropTypes.string.isRequired,
      imageUrl: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired
    })
  ).isRequired,
  formatTranslation: PropTypes.func.isRequired,
  onSiteClicked: PropTypes.func.isRequired
};

export default withViewport(withTranslation(InternationalSites));
